import { useReduxState } from 'hooks';
import { HeaderLogo, HeaderUserNav } from '.';

interface Props {
  onHelpClick: () => void;
  showBoxShadow: boolean;
  showUser: boolean;
}

const Header = ({ onHelpClick, showBoxShadow, showUser }: Props) => {
  const { theme } = useReduxState();

  return (
    <header
      className="header"
      style={showBoxShadow ? { boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)' } : {}}
    >
      <div className="container">
        <div className="header-content">
          <div className="row-sm">
            <div className="col col-center">
              <HeaderLogo />
            </div>
            <div className="col-min col-center">
              <HeaderUserNav onHelpClick={onHelpClick} showUser={showUser} />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .header {
          background-color: ${theme.headerBackgroundColor || '#fff'};
          padding: ${theme.headerPadding || '12px 0'};
          z-index: 20;
        }
        .header-content {
          padding: 0;
        }
      `}</style>
    </header>
  );
};

export default Header;
